import { render, staticRenderFns } from "./ThePiso.vue?vue&type=template&id=76785899&scoped=true&"
import script from "./ThePiso.vue?vue&type=script&lang=js&"
export * from "./ThePiso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76785899",
  null
  
)

export default component.exports